export enum AppRoutes {
  DEFAULT_EMPTY = '',
  LOGIN = 'login',
  COMMERTIAL = 'panel-comercial',
  DASHBOARD = 'panel-administrativo',
  EMAIL = 'correo',
  LEADS = 'cotizaciones-potenciales',
  CHATS = 'chats',
  TRACKING = 'seguimiento',
  CLIENTS = 'clientes',
  DASHBOARD_TABLE = 'tablero',
  OPENING_HOURS = 'horarios-disponibles',
  ORDERS_BY_LEAD = 'ordenes-por-cliente',
  FUNNEL = 'funnel',
  STATUS_CHART = 'diagrama-de-ventas',
  COMMERTIAL_EXECUTIVE_STATUS = 'compromiso-ejecutivo-comercial',
  ARCHIVED_LEADS = 'clientes-archivados',
}
